import { render, staticRenderFns } from "./AddSoldEventModal.vue?vue&type=template&id=381b2f36&"
import script from "./AddSoldEventModal.vue?vue&type=script&lang=js&"
export * from "./AddSoldEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports